var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPause = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Pause",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic-film-pause/Outlined",
    transform: "translate(4, 3)",
    fill: "#0A186E",
    opacity: 0.99,
    stroke: "#0A186E",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25,1.83673481 C4.25,0.822334251 3.57842712,0 2.75,0 L1.5,0 C0.671573257,0 0,0.822334251 0,1.83673469 L0,10.1632653 C0,11.1776659 0.671572876,12 1.5,12 L2.74999962,12 C3.57842674,12 4.24999962,11.1776659 4.24999962,10.1632653 L4.25,1.83673481 Z M2.75,1.22448991 C3.02614231,1.22448991 3.25,1.49860125 3.25,1.83673481 L3.24999962,10.1632653 C3.24999962,10.5013985 3.02614193,10.7755102 2.74999962,10.7755102 L1.5,10.7755102 C1.22385769,10.7755102 1,10.5013985 1,10.1632653 L1,1.83673481 C1,1.49860125 1.22385807,1.2244898 1.5,1.2244898 L2.75,1.22448991 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9,1.83673481 C9.9,0.822334251 9.22842712,0 8.4,0 L7.15,0 C6.32157326,0 5.65,0.822334251 5.65,1.83673469 L5.65,10.1632653 C5.65,11.1776659 6.32157288,12 7.15,12 L8.39999962,12 C9.22842674,12 9.89999962,11.1776659 9.89999962,10.1632653 L9.9,1.83673481 Z M8.4,1.22448991 C8.67614231,1.22448991 8.9,1.49860125 8.9,1.83673481 L8.89999962,10.1632653 C8.89999962,10.5013985 8.67614193,10.7755102 8.39999962,10.7755102 L7.15,10.7755102 C6.87385769,10.7755102 6.65,10.5013985 6.65,10.1632653 L6.65,1.83673481 C6.65,1.49860125 6.87385807,1.2244898 7.15,1.2244898 L8.4,1.22448991 Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Pause.6f8209a7e1c69bc1fb55b6e9293b3744.svg";